export const RSP_STATUS_META = {
    ouvert: {
        id: 'ouvert',
        label: 'Ouvert',
        shortLabel: 'À traiter',
        color: '#00B0FF',
        background: '#E3F2FD',
    },
    en_cours: {
        id: 'en_cours',
        label: 'En cours',
        shortLabel: 'En cours',
        color: '#FF9436',
        background: '#FFF3E0',
    },
    resolu: {
        id: 'resolu',
        label: 'Résolu',
        shortLabel: 'Résolu',
        color: '#4CAF50',
        background: '#E8F5E9',
    },
};

export const getRspStatusMeta = (status) => RSP_STATUS_META[status] || RSP_STATUS_META.ouvert;

export const getRspStepLabel = (step, steps) => {
    const current = steps.find(({ n }) => n === Number(step));
    return current ? current.label : steps[0]?.label || 'QQOQCCP';
};

export const buildRspOverview = (problems = []) => {
    const safeProblems = Array.isArray(problems) ? problems : [];
    const counts = safeProblems.reduce((result, problem) => {
        const status = RSP_STATUS_META[problem?.statut] ? problem.statut : 'ouvert';
        result[status] += 1;
        return result;
    }, { ouvert: 0, en_cours: 0, resolu: 0 });

    return {
        total: safeProblems.length,
        ...counts,
        active: counts.ouvert + counts.en_cours,
    };
};
